module.exports = __webpack_public_path__ + "img/rank-2.5d5d3e82.png";